import { ITagType, TagType } from "./tag-type.model";

export interface ITag {
  tagId: string;
  tagTypeId: string;
  houseFlatId: string;
  id: number;
  status: boolean;
  notes: string;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: string;
  updatedAt: string;
  tagType?: ITagType;
}

export class Tag {
  tagId: string;
  tagTypeId: string;
  houseFlatId: string;
  id: number;
  status: boolean;
  notes: string;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: string;
  updatedAt: string;
  tagType?: TagType;

  constructor(data: ITag) {
    this.tagId = data.tagId;
    this.tagTypeId = data.tagTypeId;
    this.houseFlatId = data.houseFlatId;
    this.id = data.id;
    this.status = data.status;
    this.notes = data.notes;
    this.uidCreatedBy = data.uidCreatedBy;
    this.uidUpdatedBy = data.uidUpdatedBy;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
    this.tagType = data.tagType
      ? new TagType(data.tagType)
      : undefined;
  }
}
